import { defineStore } from "pinia";
import { ref, computed } from "vue";

// PRODUCTION SETTINGS
let development = {
  active: false
}
let settings = {
  viewProjection: "EPSG:3857",
  tracker_server_url: " http://tracker.localhost:8100",
  chlorophyll_server_url: " http://chlorophyll.localhost:8200",
  hand: "right",
  showZoomControl: true,
  showScaleControl: true,
  showInfoPosition: true,
  showTeleporter: true,
  showQuickAddMedia: true,
  showMapLabels: true,
  showLocalSettingsBtn: true,
  crossWidth: 1,
  crossColor: "#ffffff",
  lang: "it",
  showInsertType: {},
  mapExtentLocked: true,
  uiSoundEnabled: true,
  uploadWithMobileConnection: true,
  uploadEnabled: true,
  backgroundFetchUserDisabled: true,
  fontSize: 0,
  pointStyle: "circle",
  olMBTilesSQLWorkers: 1,
  packsDownloadLocation: "cache",
}

const startTime = new Date()

// END PRODUCTION

switch (ENVIRONMENT) {

  case 'staging':
    settings.tracker_server_url = "https://tracker-staging.pngp.it"
    settings.chlorophyll_server_url = "https://chlorophyll-staging.pngp.it"
    break

  case 'development':
    development = {
      active: true
    }
    // settings.tracker_server_url = "https://tracker-staging.pngp.it"
    // settings.chlorophyll_server_url = "https://chlorophyll-staging.pngp.it"
    break
  case 'production':
    settings.tracker_server_url = "https://tracker.pngp.it"
    settings.chlorophyll_server_url = "https://chlorophyll.pngp.it"
    break

}

const initialSettings = JSON.parse(JSON.stringify(settings))


export const useRuntimeStore = defineStore('runtimeStore', () => {

  const runningTime = ref(0)
  const upTime = ref(0)

  const session = ref({
    user: null,
    settings: settings,
    development: development,
    map: {
      location: {
        last: null,
      },
      center: null,
      zoom: null,
      layers: null
    },
  })
  const volatile = ref({
    location: {
      follow: false,
    },
  })

  const logged = computed(() => {
    return session.value?.user !== null
  })



  const loadSession = (locale) => {

    if (localStorage.getItem("session")) {
      session.value = JSON.parse(localStorage.getItem("session"))

      locale.value = session.value?.settings?.lang || "it"
      console.log("🚛 session loaded (from localStorage, to store)")

      console.log("🧠 backend tracker: " + session.value.settings.tracker_server_url)
      console.log("🧠 backend chlorophyll: " + session.value.settings.chlorophyll_server_url)


      // fill missing settings with default values
      console.log("🌕 fill missing settings with defaults")
      for (const key in initialSettings) {
        if (!(key in session.value.settings)) {
          session.value.settings[key] = initialSettings[key]
        }
      }

      // reset value to initial default at every run here
      console.log("🚽 resettting (SOME) settings to defaults")
      // console.log("💠 reset: " + session.value.settings.chlorophyll_server_url)
      session.value.settings.showLocalSettingsBtn = initialSettings.showLocalSettingsBtn

    }
  }

  const saveSession = () => {
    localStorage.setItem("session", JSON.stringify(session.value))
    // console.log(this)
    console.log("💾 session saved (to localStorage)")
  }

  const saveUserData = (userdata) => {
    console.log(session.value)
    session.value.user = userdata
    saveSession()
    // localStorage.setItem("user", JSON.stringify(user))
    // console.log("user saved (in store, in localStorage)")
  }

  const logout = () => {
    localStorage.removeItem("session")
    session.value = {
      user: null,
      settings: settings,
      development: development,
    }
    console.log("💥 session logged out(removed from store and from localstorage))")
    window.location.reload()
  }



  const mapToggleFollow = () => {
    volatile.value.location.follow = !volatile.value.location?.follow
    saveSession()
  }

  const setFollowFalse = () => {
    volatile.value.location.follow = false
    saveSession()
  }

  const resetSettings = () => {
    session.value.settings = JSON.parse(JSON.stringify(initialSettings))
    saveSession()
  }


  setInterval(() => {
    runningTime.value = runningTime.value + 1000
    upTime.value = new Date() - startTime
  }, 1000)



  return {
    session,
    volatile,

    logged,
    loadSession,
    saveSession,
    saveUserData,
    logout,
    mapToggleFollow,
    setFollowFalse,

    resetSettings,

    runningTime,
    upTime,
  }
})
